
import { Component } from '@angular/core';
import { Permission } from '../../models/permission.model';
import { AccountService } from '../../services/account.service';
import { AlertService, MessageSeverity } from '../../services/alert.service';
import { fadeInOut } from '../../services/animations';

@Component({
    selector: 'file-upload',
    template: require('./file-upload.component.html'),
    styles: [require('./file-upload.component.css')],
    animations: [fadeInOut]
})
export class FileUploadComponent {
    uploadedFiles: any[] = [];
    downloadlink: string = "";
    showUploadButton: boolean = true;

    constructor(private accountService: AccountService, private alertService: AlertService) {
        if (this.accountService.applicationVersionName == "DEVELOPMENT") {
            this.downloadlink = "http://dev.sidder.eu/WERKINSTRUCTIE.pdf";
        } else if (this.accountService.applicationVersionName == "TEST") {
            this.downloadlink = "http://test.sidder.eu/WERKINSTRUCTIE.pdf";
        } else if (this.accountService.applicationVersionName == "RELEASE") {
            this.downloadlink = "https://app.sidder.eu/WERKINSTRUCTIE.pdf";
        } else {
            this.downloadlink = "http://dev.sidder.eu/WERKINSTRUCTIE.pdf";
        }
    }

    onError(event) {

        this.showUploadButton = true;
        this.alertService.resetStickyMessage();

        var responseText = JSON.parse(event.xhr.responseText);
        const errorMessage = responseText.error_description;

        if (errorMessage == 'wrong File') {
            this.alertService.showMessage('Bestand niet ondersteund: ' + event.files[0].name, "Alleen bestandsnamen met 4331 of 4326 of 254 of 390 of 517 of BelpexFilter kunnen worden geüpload.", MessageSeverity.warn);
        }
        else if (errorMessage == 'wrong Belpex File') {
            this.alertService.showMessage('Bestand niet ondersteund: ' + event.files[0].name, "Belpex bestandsupload ondersteunt alleen het bestandstype .xlsx.", MessageSeverity.warn);
        }
        else {
            this.alertService.showStickyMessage("Endex Bestand", "Uploaden van bestanden is mislukt", MessageSeverity.warn);
        }
    }

    onUpload(event, files) {
        this.showUploadButton = true;
        this.alertService.resetStickyMessage();
        this.alertService.showMessage("Endex Bestand", "Bestand succesvol geüpload", MessageSeverity.success);
        for (let file of event.files) {
            this.uploadedFiles.push(file);
        }
    }

    onProgress(event) {

        this.showUploadButton = false;
        this.alertService.resetStickyMessage();
        if (event.progress) {
            this.alertService.showStickyMessage("Endex Bestand", `Het uploaden van bestanden is bezig`, MessageSeverity.wait);
        }
    }

    get cangasImportPermission() {
        return this.accountService.userHasPermission(Permission.gasImportPermission);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/file-upload/file-upload.component.ts